import { mapGetters, mapMutations } from 'vuex'

export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return {
          publicPath: process.env.BASE_URL,
          isCanRequest: true, // 防止连续请求
          manageMessageList: [], // 消息管理
          confirmManageMessageList: [] // confirm 消息管理
        }
      },
      computed: {
        ...mapGetters([
          'browserIe', // 判断浏览器是否为IE
          'distributorOpenType', // 判断该渠道是否开新页面
          'token', // 登录token
          'userId',
          'userInfo',
          'vipInfo',
          'siteInfo',
          'distributorId',
          'existExpert'
        ])
      },
      methods: {
        $message(mes) {
          if (mes === undefined) return
          let message = typeof mes === 'string' ? mes : mes.message
          let flag = true
          this.manageMessageList.forEach(item => {
            if (item === message) {
              flag = false
            }
          })
          if (flag) {
            this.manageMessageList.push(message)
            setTimeout(() => {
              this.manageMessageList.splice(0, 1)
            }, 3000)
          } else {
            return
          }
          if (typeof mes === 'string') {
            this.$$message({
              message: mes,
              type: 'warning'
            })
          } else {
            this.$$message(mes)
          }
        },
        delItemFromList(curitem, list) {
          let i = -1
          list.forEach((item, index) => {
            if (curitem === item) {
              i = index
            }
          })
          if (i !== -1) {
            list.splice(i, 1)
          }
          console.log(this.confirmManageMessageList)
        },
        $$confirm(message, subtext, canceltext, title, hideCancelBtn) {
          let flag = true
          this.confirmManageMessageList.forEach(item => {
            if (item === message) {
              flag = false
            }
          })
          let showCancelButton = !hideCancelBtn // 隐藏btn按钮
          return new Promise(resolve => {
            if (!message || !flag) {
              resolve({ code: '404' })
              return
            }
            // 将消息push到管理器里
            this.confirmManageMessageList.push(message)

            this.$confirm(message, title || '', {
              confirmButtonText: subtext || '确定',
              cancelButtonText: canceltext || '取消',
              showCancelButton,
              closeOnClickModal: false,
              customClass: 'common-dialog-message-box'
            })
              .then(() => {
                this.delItemFromList(message, this.confirmManageMessageList)
                resolve({ code: '0000' })
              })
              .catch(() => {
                this.delItemFromList(message, this.confirmManageMessageList)
                resolve({ code: '404' })
              })
          })
        },
        routerGoBlank(path, q) {
          // 在新标签页打开
          let query = q || {}
          let routeUrl = this.$router.resolve({ path, query })
          window.open(routeUrl.href, '_blank')
        },
        routerReplace(path, q) {
          // 路由跳转替换当前路由
          let query = q || {}
          this.$router.replace({ path, query })
        },
        routerGo(path, q) {
          // 路由跳转
          let query = q || {}
          this.$router.push({ path, query })
        },

        ...mapMutations([
          'setbrowserIe',
          'setdistributorOpenType',
          'setToken',
          'setuserId',
          'setuserInfo',
          'setvipInfo',
          'setsiteInfo',
          'setdistributorId',
          'setexistExpert'
        ])
      }
    })
  }
}
